import BaseService from './BaseService'
import Event from '@/models/event'

export class EventsService extends BaseService<Event> {
  constructor() {
    super('events/')
  }

  public async getEvents(queryArgs) {

    Object.keys(queryArgs).forEach((key) => { if (queryArgs[key] === undefined || queryArgs[key] === '' || queryArgs[key] === null) {
      delete queryArgs[key]
    }})
    // @ts-ignore
    const urlParams  = new URLSearchParams(queryArgs)
    const result = await this.instance.get(
      this.resourcePath + '?' + urlParams.toString(),
    )
    return result.data as any
  }

  public async deleteEvents() {
    // TODO change
    const result = await this.instance.delete(
      this.resourcePath + 'delete-events/',
      {},
    )
    return result.data as any
  }
}

export default new EventsService()
